import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useNotificationBar } from '../lib/cmsStore';
export function NotificationBar() {
  const {
    data,
    isLoading
  } = useNotificationBar();
  const [dismissed, setDismissed] = useState(false);
  const barRef = useRef<HTMLDivElement>(null);
  // Set CSS variable for notification bar height so Navigation can offset itself
  useEffect(() => {
    const root = document.documentElement;
    if (!dismissed && data?.enabled && data?.message) {
      const updateHeight = () => {
        if (barRef.current) {
          const h = barRef.current.offsetHeight;
          root.style.setProperty('--notification-bar-height', h + 'px');
        }
      };
      // Small delay to let animation finish
      updateHeight();
      const timer = setTimeout(updateHeight, 350);
      return () => {
        clearTimeout(timer);
        root.style.setProperty('--notification-bar-height', '0px');
      };
    } else {
      root.style.setProperty('--notification-bar-height', '0px');
    }
  }, [dismissed, data?.enabled, data?.message]);
  if (isLoading || !data || !data.enabled || !data.message || dismissed) {
    return null;
  }
  const bgColor = data.backgroundColor || '#C6FF00';
  const txtColor = data.textColor || '#000000';
  const textStyle: React.CSSProperties = {
    fontWeight: data.textBold ? 700 : 400,
    fontStyle: data.textItalic ? 'italic' : 'normal'
  };
  return <div ref={barRef} className="relative z-[70] w-full" style={{
    backgroundColor: bgColor,
    color: txtColor
  }} data-id="element-289">
      <AnimatePresence data-id="element-290">
        <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="overflow-hidden" data-id="element-291">
          <div className="flex items-center justify-center gap-4 px-12 py-2.5 text-center" data-id="element-292">
            <span className="font-mono text-xs tracking-wide" style={textStyle} dangerouslySetInnerHTML={{
            __html: data.message
          }} data-id="element-293" />

            {data.buttonLabel && data.buttonLink && <a href={data.buttonLink} className="inline-flex items-center font-mono text-xs font-bold uppercase tracking-widest px-3 py-1 transition-opacity hover:opacity-80" style={{
            backgroundColor: txtColor,
            color: bgColor
          }} data-id="element-294">
                {data.buttonLabel}
              </a>}

            <button onClick={() => setDismissed(true)} className="absolute right-4 top-1/2 -translate-y-1/2 p-1 transition-opacity hover:opacity-60 rounded-sm" style={{
            color: txtColor
          }} aria-label="Dismiss notification" data-id="element-295">
              <XIcon className="w-3.5 h-3.5" data-id="element-296" />
            </button>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>;
}